import { alpha, type Theme, type Components } from "@mui/material/styles";

export const feedbackCustomizations: Components<Theme> = {
  MuiAlert: {
    styleOverrides: {
      root: ({ theme, ownerState }) => {
        const tone = theme.palette[ownerState.severity || "info"];
        const filled = ownerState.variant === "filled";
        return {
          borderRadius: 6,
          border: `1px solid ${alpha(tone.main, 0.4)}`,
          backgroundColor: filled ? tone.main : alpha(tone.main, 0.08),
          color: filled ? tone.contrastText : theme.palette.text.primary,
          "& .MuiAlert-icon": { color: filled ? "inherit" : tone.main },
          "& .MuiAlert-message": { minWidth: 0, overflowWrap: "anywhere" },
        };
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme }) => ({
        borderRadius: 8,
        border: `1px solid ${theme.palette.divider}`,
        backgroundImage: "none",
        boxShadow: `0 16px 48px ${alpha(theme.palette.common.black, theme.palette.mode === "dark" ? 0.3 : 0.12)}`,
        margin: 24,
      }),
    },
  },
  MuiDialogTitle: {
    styleOverrides: { root: { fontWeight: 500, padding: "24px 24px 16px" } },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: { padding: "16px 24px 24px", gap: 8, flexWrap: "wrap" },
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: ({ theme }) => ({
        height: 5,
        borderRadius: 4,
        backgroundColor: alpha(theme.palette.primary.main, 0.12),
      }),
      bar: { borderRadius: 4 },
    },
  },
  MuiSkeleton: {
    defaultProps: { animation: false },
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: alpha(theme.palette.text.primary, 0.08),
        borderRadius: 4,
      }),
    },
  },
};
